// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2SUcs","label":"LabeledBox_label__1gsxs"};